/* src/app/shared/invoice/retired/headers/retired-css.css */
span {
  padding: .25em 0;
  display: inline-block;
}
/*# sourceMappingURL=retired-css.css.map */
